import CustomDialogWrapper from './CustomDialogWrapper';
import CustomDialogContent from './CustomDialogContent';

export { CustomDialogContent };
export default CustomDialogWrapper;
